import { useRef } from 'react';

import { PrintableRootPage } from 'components/page/page-2';

import { Tooltip } from 'antd';
import { ExportAsPDFButton } from 'components/button/button-export-as-pdf';
import { ConcussionRxPrintContext } from 'lib/utils/print';
import { useParams } from 'react-router-dom';
import { usePatientInfoContext } from '../_utils/patient-info/hook-context-patientinfo';
import { DisplayFriendlyPatientIdentifier } from '../../clinician/patient/schedule-test/page-schedule-test';
import { PatientSummaryDashboard } from './patient-summary-dashboard';
import { usePrintReportPipeline } from './report/utils/use-printReportPipeline';

/**
 * A page that allows the patient to quickly view their symptoms and concussion complexity
 */
export function PatientSummary() {
  const params = useParams<{ patientId: string }>();
  const { patientInfo } = usePatientInfoContext();

  const printReportPipeline = usePrintReportPipeline({
    patientId: params.patientId
  });

  const printableDomElementRef = useRef<Element | null>(null);
  // return     <ConcussionRxPrintContext
  //     content={() => printableDomElementRef.current}
  //     handlePrintOverride={printReportPipeline.handlePrint}
  //   >
  //           <PrintableRootPage
  //       title={`${pluralize(state.patient.displayName)} ConcussionRx Summary`}
  //       hasError={state.hasError}
  //       isLoading={state.isLoading}
  //       extra={[
  //         <Tooltip
  //           key={4}

  //           // No tooltip message for now
  //           title={
  //             ''
  //           }
  //         >
  //           <ExportAsPDFButton text="Print Report" />
  //         </Tooltip>
  //       ]}
  //       ref={printableDomElementRef}
  //     >

  //     </PrintableRootPage>
  //   </ConcussionRxPrintContext>
  return (
    <ConcussionRxPrintContext
      content={() => printableDomElementRef.current}
      handlePrintOverride={printReportPipeline.handlePrint}
    >
      <PrintableRootPage
        hasError={patientInfo.hasError}
        isLoading={patientInfo.isLoading}
        extra={[
          <Tooltip
            key={4}
            // No tooltip message for now
            title={''}
          >
            <ExportAsPDFButton text="Print Report" />
          </Tooltip>
        ]}
        ref={printableDomElementRef}
      >
        <DisplayFriendlyPatientIdentifier
          patient={patientInfo.patient}
          pluralize
          suffix="summary"
        />
        <PatientSummaryDashboard />
      </PrintableRootPage>
    </ConcussionRxPrintContext>
  );
}
